"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deconstructDefaultMarkup = exports.constructDefaultMarkup = exports.defaultMarkupRegex = void 0;
exports.defaultMarkupRegex = /@\[.+?]\(.+?\)/;

const constructDefaultMarkup = (id, display) => {
  return `@[${display}](${id})`;
};

exports.constructDefaultMarkup = constructDefaultMarkup;
let defaultMarkupIdRegex;
let defaultMarkupDisplayRegex; //cannot declare this regex in global scope as safari doesn't support lookahead/lookbehind
//when used on supported browsers, on the first call to `deconstructDefaultMarkup` the regex will be initiated

const initRegex = () => {
  defaultMarkupIdRegex = new RegExp("(?<=\\().+?(?=\\))");
  defaultMarkupDisplayRegex = new RegExp("(?<=\\[).+?(?=])");
};

const deconstructDefaultMarkup = markup => {
  var _a, _b, _c, _d;

  if (!defaultMarkupDisplayRegex || !defaultMarkupIdRegex) {
    initRegex();
  }

  const id = (_b = (_a = defaultMarkupIdRegex.exec(markup)) === null || _a === void 0 ? void 0 : _a.pop()) !== null && _b !== void 0 ? _b : null;
  const display = (_d = (_c = defaultMarkupDisplayRegex.exec(markup)) === null || _c === void 0 ? void 0 : _c.pop()) !== null && _d !== void 0 ? _d : null;
  return {
    id,
    display
  };
};

exports.deconstructDefaultMarkup = deconstructDefaultMarkup;